import { c as _c } from "react/compiler-runtime";
import { classNames, FlexColumn, Media, pageContainerClassName, Separator } from "@opensea/ui-kit";
import { fullBleedVariants } from "@/styles/utils/page-container";
import { mediaColumnClassNames } from "./styles";
export function ItemPageLayout(t0) {
  const $ = _c(35);
  const {
    actions,
    variant: t1,
    media,
    details,
    tabs,
    title,
    metadataChips,
    stats,
    shouldUseSquareMedia: t2
  } = t0;
  const variant = t1 === undefined ? "page" : t1;
  const shouldUseSquareMedia = t2 === undefined ? false : t2;
  const isModal = variant === "modal";
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = fullBleedVariants();
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  const t4 = isModal ? "px-4 lg:px-6" : pageContainerClassName;
  let t5;
  if ($[1] !== t4) {
    t5 = classNames("relative w-full lg:grid lg:grid-cols-12", t4);
    $[1] = t4;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  let t6;
  if ($[3] !== variant) {
    t6 = classNames(mediaColumnClassNames({
      variant
    }), "-mx-4 px-4 lg:mx-0 lg:px-0");
    $[3] = variant;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  const t7 = isModal ? "" : "lg:max-w-[calc(1920px/2)]";
  const t8 = shouldUseSquareMedia ? "aspect-square max-h-full w-full" : "size-full";
  let t9;
  if ($[5] !== t7 || $[6] !== t8) {
    t9 = classNames("relative items-center justify-center py-4 lg:py-6 lg:pr-6", t7, t8);
    $[5] = t7;
    $[6] = t8;
    $[7] = t9;
  } else {
    t9 = $[7];
  }
  let t10;
  if ($[8] !== media || $[9] !== t9) {
    t10 = <FlexColumn className={t9}>{media}</FlexColumn>;
    $[8] = media;
    $[9] = t9;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] !== t10 || $[12] !== t6) {
    t11 = <FlexColumn className={t6}>{t10}</FlexColumn>;
    $[11] = t10;
    $[12] = t6;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = classNames("3xl:col-span-6 gap-4 bg-bg-app pt-4 pb-40 lg:col-span-7 lg:pt-6 lg:pb-16 lg:pl-6", "w-full lg:max-w-[calc(1920px/2)]");
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  let t13;
  if ($[15] !== actions || $[16] !== stats) {
    t13 = stats || actions ? <Media greaterThanOrEqual="md"><FlexColumn className="mt-2 gap-4 rounded-lg border border-border-1 bg-bg-primary p-4">{stats}<Separator />{actions}</FlexColumn></Media> : null;
    $[15] = actions;
    $[16] = stats;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  let t14;
  if ($[18] !== details || $[19] !== metadataChips || $[20] !== t13 || $[21] !== tabs || $[22] !== title) {
    t14 = <FlexColumn className={t12}>{title}{details}{metadataChips}{t13}{tabs}</FlexColumn>;
    $[18] = details;
    $[19] = metadataChips;
    $[20] = t13;
    $[21] = tabs;
    $[22] = title;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== t11 || $[25] !== t14 || $[26] !== t5) {
    t15 = <div className={t5}>{t11}{t14}</div>;
    $[24] = t11;
    $[25] = t14;
    $[26] = t5;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  let t16;
  if ($[28] !== actions) {
    t16 = <Media lessThan="md">{actions}</Media>;
    $[28] = actions;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  let t17;
  let t18;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <div className="absolute top-0 left-0 z-[-1] hidden h-full w-1/2 bg-bg-primary lg:block" />;
    t18 = <div className="absolute top-0 right-0 z-[-1] hidden h-full w-1/2 bg-bg-app lg:block" />;
    $[30] = t17;
    $[31] = t18;
  } else {
    t17 = $[30];
    t18 = $[31];
  }
  let t19;
  if ($[32] !== t15 || $[33] !== t16) {
    t19 = <main className={t3}>{t15}{t16}{t17}{t18}</main>;
    $[32] = t15;
    $[33] = t16;
    $[34] = t19;
  } else {
    t19 = $[34];
  }
  return t19;
}